@use 'themes/westfield' as *;
@use 'tools/dirg' as *;

.wrapper {
  display: flex;
  flex-flow: column;
}

.buttonContainer {
  display: flex;
  flex-flow: column;
  gap: 16px;
}

.or {
  margin-top: units(1.5);
  margin-bottom: units(1.5);
}
